import { useQuery } from 'convex/react'
import { api } from '@ppwr/convex/_generated/api'
import type { Id } from '@ppwr/convex/_generated/dataModel'

/**
 * Server-truth spectator status. Replaces the old `isSpectating` URL flag.
 *
 * `isSpectator` is true iff the caller is listed in `game.observerUserIds`
 * AND has no live `players` row. `tournamentId` is surfaced when the game
 * is a tournament table so the spectator-exit UI can route back to the
 * tournament lobby without the client needing to thread it through routes.
 *
 * Returns `undefined` while loading or when args are missing — callers should
 * treat that the same as "not a spectator" for rendering, since the alternative
 * is flashing the observer UI on mount.
 */
export function useSpectatorStatus(gameId: Id<'games'> | undefined, userId: string | undefined) {
  const data = useQuery(
    api.games.queries.getMySpectatorStatus,
    gameId && userId ? { gameId, userId } : 'skip'
  )
  return {
    isSpectator: data?.isSpectator ?? false,
    tournamentId: data?.tournamentId as Id<'tournaments'> | undefined,
    loaded: data !== undefined
  }
}
